async function sendEmail(type, payload) {
  const res = await fetch("/.netlify/functions/send-email", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type, ...payload }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to send");
  }
  return res.json();
}

export const submitContactMessage = (payload) =>
  sendEmail("contact", payload);

export const submitTransportRequest = (payload) =>
  sendEmail("transport", payload);

export const submitCarrierApplication = (payload) =>
  sendEmail("carrier", payload);
